(function () {
    'use strict';

    // Change to enum once we use TypeScript.
    const PasswordStrength = Object.freeze({
        TOO_SHORT: -1,
        VERY_WEAK: 0,
        WEAK: 1,
        FAIR: 2,
        GOOD: 3,
        STRONG: 4
    });

    angular.module("app").controller("UpdatePasswordController", UpdatePasswordController);

    UpdatePasswordController.$inject = ["$scope", "passwordPolicy", "passwordStrengthService", "HabilNavigator"];

    function UpdatePasswordController($scope, passwordPolicy, passwordStrengthService, HabilNavigator) {
        const vm = this;
        const MINIMUM_PASSWORD_LENGTH = passwordPolicy.minimumLength;

        vm.currentPassword = undefined;
        vm.newPassword = "";
        vm.confirmPassword = "";
        vm.strengthMeterValue = 0;
        vm.isStrengthMeterVisible = false;
        vm.passwordStrengthText = "";
        vm.passwordStrengthTooltipText = "";
        vm.disabled = true;
        vm.valid = false;

        vm.handlePasswordKeyUp = handlePasswordKeyUp;
        vm.handleSubmit = handleSubmit;
        vm.cancelUpdate = cancelUpdate;

        let isWeakPassword = false;

        //$scope.$watchGroup([() => vm.newPassword, () => vm.confirmPassword], () => { vm.valid = vm.newPassword && vm.newPassword === vm.confirmPassword; });
        $scope.$watchGroup([() => vm.currentPassword, () => vm.newPassword, () => vm.confirmPassword], () => { vm.valid = (vm.currentPassword === undefined || vm.currentPassword) && vm.newPassword && vm.newPassword === vm.confirmPassword; });

        const setPasswordStrengthText = (score) => {
            let text = "";
            switch (score) {
                case PasswordStrength.TOO_SHORT:
                    text = $scope.translations["Manage_Account_PasswordStrength_TooShort"];
                    break;
                case PasswordStrength.VERY_WEAK:
                    text = $scope.translations["Manage_Account_PasswordStrength_VeryWeak"];
                    break;
                case PasswordStrength.WEAK:
                    text = $scope.translations["Manage_Account_PasswordStrength_Weak"];
                    break;
                case PasswordStrength.FAIR:
                    text = $scope.translations["Manage_Account_PasswordStrength_Fair"];
                    break;
                case PasswordStrength.GOOD:
                    text = $scope.translations["Manage_Account_PasswordStrength_Good"];
                    break;
                case PasswordStrength.STRONG:
                    text = $scope.translations["Manage_Account_PasswordStrength_Strong"];
                    break;
            }

            vm.passwordStrengthText = text;
        };

        const setPasswordStrengthTooltipText = (text) => {
            vm.passwordStrengthTooltipText = text || "";
        };

        const getFeedbackTooltipText = (feedback) => {
            if (!feedback || !feedback.warning) {
                return null;
            }

            if (!feedback.suggestions || !feedback.suggestions.length) {
                return feedback.warning;
            }

            return `${feedback.warning}\n` + feedback.suggestions.map(s => `- ${s}`).join("\n");
        };

        const getPasswordStrengthScoreAndFeedback = (password) => {
            if (!password || password.length < MINIMUM_PASSWORD_LENGTH) {
                return {
                    score: PasswordStrength.TOO_SHORT,
                    feedback: $scope.translations["Manage_Account_PasswordStrength_TooShort"]
                };
            }

            const trimmedPassword = password.trim(); // We trim the password on the back-end.

            const {
                score,
                feedback
            } = passwordStrengthService.check(trimmedPassword);

            return {
                score,
                feedback
            };
        };

        function handlePasswordKeyUp(event) {
            const enteredPassword = event.target.value;

            if (!enteredPassword.length) {
                isWeakPassword = true;
                vm.isStrengthMeterVisible = false;
                vm.disabled = true;
                return;
            }

            const {
                score,
                feedback
            } = getPasswordStrengthScoreAndFeedback(enteredPassword);

            setPasswordStrengthText(score);
            setPasswordStrengthTooltipText(getFeedbackTooltipText(feedback));
            
            isWeakPassword = enteredPassword.length < MINIMUM_PASSWORD_LENGTH || score < PasswordStrength.FAIR;

            vm.strengthMeterValue = score <= 1 ? 1 : score;
            vm.isStrengthMeterVisible = true;

            vm.disabled = isWeakPassword;
        };

        function handleSubmit(event) {
            if (canSubmit()) {
                return true;
            }

            event.preventDefault();

            return false;
        };

        const canSubmit = () => (vm.currentPassword === undefined || !!vm.currentPassword) && !vm.disabled && !isWeakPassword;

        function cancelUpdate() {
            HabilNavigator.OpenRoute("Manage");
        };
    };

})();